// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"800e1095","453":"39c5493b","484":"c939e234","551":"9fd78929","869":"2f829dad","974":"9ed1b39c"}[chunkId] + ".chunk.js";
};